export default __webpack_public_path__ + "static/media/Preferencias.b389b667.png";